var End = {
  key: 'End',
  which: 35,
  keyCode: 35,
  code: 'Numpad1'
};
var Home = {
  key: 'Home',
  which: 36,
  keyCode: 36,
  code: 'Numpad7'
};
var ArrowLeft = {
  key: 'ArrowLeft',
  which: 37,
  keyCode: 37,
  code: 'ArrowLeft'
};
var ArrowRight = {
  key: 'ArrowRight',
  which: 39,
  keyCode: 39,
  code: 'ArrowRight'
};

export { ArrowLeft, ArrowRight, End, Home };
//# sourceMappingURL=keys.js.map
